function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.2 10c1-.9 1.2-2.3.7-3.5l-2.1 2c-.2.2-.5.2-.7 0l-1.1-1c-.2-.2-.2-.5 0-.7l2.1-2.1c-1.2-.5-2.6-.2-3.5.7S8.4 7.7 8.9 9l-4.6 4.5c-.3.3-.4.8-.3 1.2s.5.8.9.9.9 0 1.2-.3l4.6-4.6c1.2.6 2.6.3 3.6-.7zm-4.8.2l-4.2 4.3",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: ".5",
  stroke: "currentColor"
}));